<template>
  <div v-if="info" class="jin-m-base">
    <div v-if="info.user_name" class="info">{{ info.user_name }} | {{ info.age }}岁</div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m-base {
  .info {
    margin-top: 20px;
    font-size: 15px;
    color: #3d4351;
    line-height: 18px;
  }
}
</style>
